import { render, staticRenderFns } from "./BulkSendInvoiceModal.vue?vue&type=template&id=4bc2b186&"
import script from "./BulkSendInvoiceModal.vue?vue&type=script&lang=js&"
export * from "./BulkSendInvoiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BulkSendInvoiceModal.vue"
export default component.exports